import Index from '@/pages/Index';
import Router from 'vue-router';
import Vue from 'vue';
import path from './constants/path';
import store from './store/';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import AuthClient from '@/utils/auth';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    // 常にトップ位置にスクロール
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: path.root,
      name: 'Index',
      component: Index
    },
    /**
     * キャビネット
     */
    {
      path: path.cabinetMaster,
      name: 'CabinetMaster',
      component: () => import('@/pages/cabinet_drive/CabinetMaster'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * タグルート（キャビネット）
     */
    {
      path: path.companyContractTagList,
      name: 'ContractTagList',
      component: () => import('@/pages/common/ContractTagList'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * 契約当事者ルート（キャビネット）
     */
    {
      path: path.clientList,
      name: 'ClientList',
      component: () => import('@/pages/common/client/ClientList'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * 独自ラベルルート
     */
    {
      path: path.originalLabelList,
      name: 'OriginalLabelList',
      component: () => import('@/pages/common/original_label/OriginalLabelList'),
      meta: {
        requiresAuth: true
      }
    },
    /**
     * ユーザー認証
     */
    {
      path: path.login,
      name: 'Login',
      component: Login,
      props: true
    },
    /**
     * 認証コールバック
     */
    {
      path: path.authCallback,
      name: 'AuthCallback',
      component: AuthCallback
    },
    /**
     * デフォルトルート 404
     */
    {
      path: path.pageNotFound,
      name: 'PageNotFound',
      component: () => import('@/pages/lp/PageNotFound')
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.dispatch('loading/setIsLoadingCircular', false);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    AuthClient.isAuthenticated()
      .then((isAuthenticated) => {
        if (isAuthenticated) {
          next();
          return;
        }
        next({ name: 'Login', query: { redirect: to.fullPath } });
      })
      .catch((err) => {
        console.error('isAuthenticated failed', err);
        next({ name: 'Login', query: { redirect: to.fullPath } });
      });
  } else {
    // ログインが不要な画面であればそのまま次へ
    next();
  }
});

router.afterEach((to, from) => {
  // ページ遷移後はスクロールをトップへ
  window.scrollTo(0, 0);
});

export default router;
